module.exports = __webpack_public_path__ + "static/media/8.06414061.jpg";